export default function Footer() {
    return (
        <header>
            <h1>Footer</h1>
        </header>
    );
}